const Operator = () =>
  import(
    /* webpackChunkName: "courier-operator" */ '@/pages/courier/operator/index.vue'
  )
const CreateOperator = () =>
  import(
    /* webpackChunkName: "courier-operator" */ '@/pages/courier/operator/create.vue'
  )
const EditOperator = () =>
  import(
    /* webpackChunkName: "courier-operator" */ '@/pages/courier/operator/edit.vue'
  )
const DetailOperator = () =>
  import(
    /* webpackChunkName: "courier-operator" */ '@/pages/courier/operator/detail.vue'
  )

export default {
  path: 'operator',
  meta: {
    label: 'operator',
    auth: 'operator'
  },
  component: {
    name: 'Operator',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CourierOperatorReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Operator
    },
    {
      name: 'CourierCreateOperator',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateOperator
    },
    {
      name: 'CourierEditOperator',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditOperator,
      props: true
    },
    {
      name: 'CourierDetailOperator',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'report'
      },
      component: DetailOperator,
      props: true
    }
  ]
}
